module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "printNav",
    staticClass: "md-left export-nav-wrapper"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('div', {
    staticClass: "option-box"
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Print:")]), _vm._v(" "), _c('div', {
    staticClass: "chrome-content"
  }, [_c('span', {
    staticClass: "option-title"
  }, [_vm._v("Choose your format to print or save your project as a PDF file with all visible layers and text.")]), _vm._v(" "), (_vm.hideStructureMarks) ? _c('span', {
    staticClass: "option-note"
  }, [_vm._v("You have structure marks hidden on your script, so they will not appear in the printed PDF.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "option-content"
  }, [_c('div', {
    staticClass: "option-content-block"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        return _vm.openPrint(false)
      }
    }
  }, [_vm._v("Portrait")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("This option will only print the PDF and any cues and notes you have located on that document. Cues located in the margins will not be visible.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "option-box"
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Export:")]), _vm._v(" "), _c('span', {
    staticClass: "option-title"
  }, [_vm._v("Download CSV file with the following information:")]), _vm._v(" "), _c('div', {
    staticClass: "option-content"
  }, [_c('md-switch', {
    staticClass: "md-primary",
    model: {
      value: (_vm.allLayers),
      callback: function($$v) {
        _vm.allLayers = $$v
      },
      expression: "allLayers"
    }
  }, [_vm._v("All Layers")])], 1), _vm._v(" "), _c('div', {
    staticClass: "option-content"
  }, _vm._l((_vm.layers), function(layer) {
    return (!_vm.allLayers) ? _c('md-checkbox', {
      key: layer.id,
      model: {
        value: (layer.selected),
        callback: function($$v) {
          _vm.$set(layer, "selected", $$v)
        },
        expression: "layer.selected"
      }
    }, [_vm._v(_vm._s(layer.title))]) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "option-action"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.exportProject
    }
  }, [_vm._v("Export")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a75d3b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/nav.vue
// module id = 1256
// module chunks = 21